import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate('/admin/dashboard');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Login failed. Please try again.';
      setError(typeof errorMessage === 'string' ? errorMessage : 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#FAFAFA' }}>
      <div className="w-full max-w-md">
        <div className="bg-white p-8 rounded-lg shadow-lg" style={{ borderTop: '4px solid #E5A93D' }}>
          <div className="text-center mb-8">
            <h1 className="text-3xl mb-2" style={{ color: '#0D2C22', fontFamily: 'Georgia, serif' }}>
              Admin Login
            </h1>
            <p style={{ color: '#666' }}>Sales Leads Pro Dashboard</p>
          </div>

          {error && (
            <div className="mb-4 p-3 rounded" style={{ background: '#fee', color: '#c33' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block mb-2 font-medium" style={{ color: '#0D2C22' }}>
                Email Address
              </label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2"
                style={{ borderColor: '#ddd', color: '#0D2C22' }}
              />
            </div>

            <div className="mb-6">
              <label className="block mb-2 font-medium" style={{ color: '#0D2C22' }}>
                Password
              </label>
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2"
                style={{ borderColor: '#ddd', color: '#0D2C22' }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded font-medium transition-colors"
              style={{
                background: loading ? '#ccc' : '#0D2C22',
                color: '#fff',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm hover:underline"
              style={{ color: '#E5A93D' }}
            >
              ← Back to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;